/**
 * Created by mac on 12/26/22
 */

const FlatMapOrangery = {
    init: function () {
        const tabs = [];
        const tabIcons = this.getTabIcons();

        const codesByTab = this.groupFamiliesByTab();

        for (const tabId in codesByTab) {
            tabs.push({
                icon: tabIcons[tabId],
                rows: codesByTab[tabId].map((family) => this.listUnitsByCode(family, true))
            });
            if (this.preSelectedTab === true) {
                this.preSelectedTab = tabId;
            }
        }

        tabs.forEach((tab) => {
            tab.rows.unshift([{
                eraser: true,
                id: tab.id,
                itemIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon),
                minimizedIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon)
            }]);
        });

        this.tabs = tabs;
    },

    clear: function () {
        this.tabs = [];
    },

    getTabIcons: function () {
        return [
            undefined,
            bundles.windows.frames.tab_icon_resource,
            undefined,
            bundles.windows.frames.tab_icon_source,
            bundles.windows.frames.tab_icon_chest,
            bundles.windows.frames.tab_icon_valuable,
            bundles.windows.frames.tab_icon_booster
        ];
    },

    groupFamiliesByTab: function () {
        const codesByTab = {};

        Object.keys(Merge2.current.families).forEach((code) => {
            if (["unknown", "multiCellBody", "thirdelement"].indexOf(code) !== -1) {
                return;
            }

            const tabId = this.findTabId(code);

            if (!codesByTab[tabId]) {
                codesByTab[tabId] = [];
            }

            codesByTab[tabId].push(code);
        });

        return codesByTab;
    },

    findTabId: function (code) {
        const tabs = UnitsLibrary.codesByTabId.main;
        for (let i = 0; i < tabs.length; i++) {
            if (tabs[i].indexOf(code) !== -1) {
                return i;
            }
        }
    },

    listUnitsByCode: function (family, preferStatic) {
        const units = [];

        for (let stage = 0; stage < Families[family].units.length; ++stage) {
            const unit = {
                code: family,
                stage
            };

            unit.itemIcon = UnitView.getUnitImage(unit, { preferStatic });
            unit.minimizedIcon = UnitView.getUnitImage(unit, { preferStatic });

            units.push(unit);
        }

        return units;
    },

    getItemCode: function (item) {
        return item.stage ? Unit.GetKey(item) : item.code;
    },

    onClick: function (cell, selected) {
        if (!selected) {
            return false;
        }

        const unit = Merge2.current.field.getUnit(cell.x, cell.y);
        if (selected.eraser && unit) {
            unit.debugRemove();
            return true;
        }

        if (!selected.eraser && !unit) {
            if (Unit.CreateDebug(selected, cell)) {
                cleverapps.effects.fire("merge.spawn.landing");
            }
        }
    }
};